import { render, staticRenderFns } from "./CrudBOMDialog.vue?vue&type=template&id=6c2519fd&scoped=true"
import script from "./CrudBOMDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrudBOMDialog.vue?vue&type=script&setup=true&lang=ts"
import style1 from "./CrudBOMDialog.vue?vue&type=style&index=1&id=6c2519fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2519fd",
  null
  
)

export default component.exports